(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-runtime"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dialog-open]');

    if (opener) {
      const dialog = document.getElementById(opener.dataset.dialogOpen);

      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    }

    const closer = event.target.closest('[data-dialog-close]');

    if (closer) {
      closer.closest('dialog')?.close();
    }

    const zoomImage = event.target.closest('.zoom-dialog img');

    if (zoomImage) {
      const dialog = zoomImage.closest('.zoom-dialog');
      dialog.classList.toggle('is-zoomed');
      zoomImage.style.transformOrigin = '50% 50%';
    }

    const filterToggle = event.target.closest('[data-filter-toggle]');

    if (filterToggle) {
      const filters = document.querySelector('[data-filters]');
      filters?.classList.toggle('is-open');

      filterToggle.setAttribute(
        'aria-expanded',
        String(filters?.classList.contains('is-open'))
      );
    }
  });

  document.addEventListener('pointermove', (event) => {
    const image = event.target.closest('.zoom-dialog.is-zoomed img');

    if (!image || event.pointerType !== 'mouse') return;

    const container = image.closest('.dialog-inner');
    const bounds = container.getBoundingClientRect();

    const horizontal = Math.min(
      100,
      Math.max(0, ((event.clientX - bounds.left) / bounds.width) * 100)
    );

    const vertical = Math.min(
      100,
      Math.max(0, ((event.clientY - bounds.top) / bounds.height) * 100)
    );

    image.style.transformOrigin = `${horizontal}% ${vertical}%`;
  });

  document.querySelectorAll('dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', () => {
      if (!dialog.classList.contains('zoom-dialog')) return;

      const image = dialog.querySelector('img');
      dialog.classList.remove('is-zoomed');

      if (image) {
        image.style.transformOrigin = '50% 50%';
      }
    });
  });

  document.querySelectorAll('[data-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variants = JSON.parse(
      root.querySelector('[data-product-json]')?.textContent || '[]'
    );

    const optionGroups = [
      ...root.querySelectorAll('[data-option-group]')
    ];

    const forms = [
      ...root.querySelectorAll('form[action*="/cart/add"]')
    ];

    const submitButtons = root.querySelectorAll('[data-add-to-cart]');

    const updateVariant = () => {
      const selected = optionGroups.map(
        (group) =>
          group.querySelector('[aria-pressed="true"]')?.dataset.optionValue
      );

      const variant = variants.find(
        (item) =>
          item.options.every(
            (option, index) => option === selected[index]
          )
      );

      forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');

        if (input) {
          input.value = variant?.id || '';
        }
      });

      root.querySelectorAll('[data-live-price]').forEach((price) => {
        const source = root.querySelector(
          `[data-price-variant="${variant?.id}"]`
        );

        if (source) {
          price.innerHTML = source.innerHTML;
        }
      });

      submitButtons.forEach((button) => {
        button.disabled = !variant || !variant.available;

        button.textContent = variant?.available
          ? button.dataset.availableText
          : button.dataset.soldOutText;
      });

      if (variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    root.querySelectorAll('[data-option-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-option-group]');

        group
          .querySelectorAll('[data-option-button]')
          .forEach((peer) => peer.setAttribute('aria-pressed', 'false'));

        button.setAttribute('aria-pressed', 'true');
        updateVariant();
      });
    });
  });

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  if (reducedMotion.matches) {
    document
      .querySelectorAll('.hero-video')
      .forEach((video) => video.pause());
  }
  if (!window.vonjonCookieControlsBound) {
    window.vonjonCookieControlsBound = true;

    const labels = document.getElementById('VjCookieLabels')?.dataset;
    const byId = (id) => document.getElementById(id);

    const setText = (node, text) => {
      if (node && text && node.textContent !== text) {
        node.textContent = text;
      }
    };

    const canOpen = () =>
      typeof window.privacyBanner?.showPreferences === 'function';

    const openPreferences = async () => {
      const message = byId('VjCookieError');

      if (message) message.textContent = '';

      try {
        await window.privacyBanner.showPreferences();
      } catch {
        setText(message, labels.error);
      }
    };

    const enhanceCookies = () => {
      if (!labels) return;

      const banner = byId('shopify-pc__banner');
      const buttons = banner?.querySelector('.shopify-pc__banner__btns');

      if (buttons) {
        const accept = byId('shopify-pc__banner__btn-accept');
        const decline = byId('shopify-pc__banner__btn-decline');
        let preferences = byId('shopify-pc__banner__btn-manage-prefs');

        if (!preferences && canOpen()) {
          preferences = document.createElement('button');
          preferences.id = 'shopify-pc__banner__btn-manage-prefs';
          preferences.className = preferences.id;
          preferences.type = 'button';
          preferences.addEventListener('click', openPreferences);
          buttons.append(preferences);
        }

        setText(accept, labels.acceptAll);
        setText(decline, labels.essentialsOnly);
        setText(
          preferences?.querySelector('span') || preferences,
          labels.preferences
        );

        preferences?.removeAttribute('hidden');

        const ordered = [accept, decline, preferences].filter(Boolean);
        const current = [...buttons.children].filter(
          (node) => ordered.includes(node)
        );

        if (ordered.some((node, index) => current[index] !== node)) {
          buttons.append(...ordered);
        }
      }

      const panel = byId('shopify-pc__prefs__dialog');

      if (panel) {
        setText(
          byId('shopify-pc__prefs__header-title'),
          labels.settings
        );
        setText(
          byId('shopify-pc__prefs__header-save'),
          labels.confirm
        );
        setText(
          byId('shopify-pc__prefs__header-accept'),
          labels.acceptAll
        );
        setText(
          byId('shopify-pc__prefs__header-decline'),
          labels.essentialsOnly
        );

        [
          ['essential', labels.essential],
          ['preferences', labels.functional],
          ['analytics', labels.performance],
          ['marketing', labels.marketing]
        ].forEach(([category, text]) => {
          const label = byId(
            `shopify-pc__prefs__${category}`
          )?.querySelector('label');

          const textNode = label && [...label.childNodes].find(
            (node) =>
              node.nodeType === Node.TEXT_NODE &&
              node.textContent.trim()
          );

          if (textNode && textNode.textContent.trim() !== text) {
            textNode.textContent = text + ' ';
          }
        });
      }

      const footer = document.querySelector(
        '.vonjon-footer__bottom > div'
      );

      if (footer && canOpen() && !byId('VjCookieReopen')) {
        const button = document.createElement('button');
        button.id = 'VjCookieReopen';
        button.type = 'button';
        button.className = 'vj-cookie-reopen';
        button.setAttribute('aria-haspopup', 'dialog');
        button.textContent = labels.reopen;
        button.addEventListener('click', openPreferences);

        const message = document.createElement('span');
        message.id = 'VjCookieError';
        message.setAttribute('role', 'alert');

        footer.append(button, message);
      }
    };

    let frame;

    const schedule = () => {
      if (frame) return;

      frame = requestAnimationFrame(() => {
        frame = undefined;
        enhanceCookies();
      });
    };

    enhanceCookies();

    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('load', (event) => {
      if (event.target instanceof HTMLScriptElement) schedule();
    }, true);

    window.addEventListener('load', schedule, { once: true });
  }
  } catch(e) { console.error(e); }
})();

})();
